import { storeToRefs } from 'pinia';
import { computed, type MaybeRefOrGetter, toValue } from 'vue';
import { useCompanyStore } from '@/stores/company';
import { useTreatwellStore } from '@/stores/treatwell';
import type { TreatwellVenue } from '@/types';
import unleash from '@/unleash';

// When the Profile tasks count as done, shared by the Profile page and the dashboard's next steps
export const useProfileTasks = (
  treatwellVenue: MaybeRefOrGetter<Partial<TreatwellVenue> | null>,
) => {
  const { treatwellStatus, hasActiveVenue } = storeToRefs(useTreatwellStore());
  const { isTreatwellUser } = useCompanyStore();

  const descriptionDone = computed(
    () => treatwellStatus.value.descriptionProvided || hasActiveVenue.value,
  );
  // A function, not a computed: unleash flags aren't reactive, so a computed would keep a stale value
  const showPhotosTask = () =>
    isTreatwellUser || unleash.isEnabled('TW_MP_PHOTOS_TASK');
  const photosDone = computed(
    () => (toValue(treatwellVenue)?.images?.length ?? 0) >= 5,
  );
  const profileDone = computed(
    () => descriptionDone.value && (!showPhotosTask() || photosDone.value),
  );

  return { descriptionDone, showPhotosTask, photosDone, profileDone };
};
